import arrowColor from './arrow-color';
import textColor from './text-color';
import textPlaceholderColor from './text-placeholder-color';
import listTextColor from './list-text-color';
import listPlateBackground from './list-plate-background';
import listRowBackground from './list-row-background';

export default {
  arrowColor,
  textColor,
  textPlaceholderColor,
  listTextColor,
  listPlateBackground,
  listRowBackground,
};
